import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { AppConfig } from "../app.config";

@Injectable({
    providedIn: 'root',
})
export class LimitCategoryService extends BaseService {

    private serviceUrl = `${this.config.getConfig('serviceBaseUrl')}api/limitCategory`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected override snackBar: MatSnackBar,
        protected override oauthService: OAuthService,
        private loadingTask: LoadingTask,
        protected override router: Router,
        private config: AppConfig) {
        super(router, coreData, oauthService, snackBar);
    }

    delete(limitCategoryCode: string) {

        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${limitCategoryCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('delete')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}